export function useToggleHotjarFeedback() {
  return { showHotjarButton, hideHotjarButton };
}

const getHotjarFeedbackButton = () =>
  document.querySelector<HTMLDivElement>('._hj_feedback_container');

function showHotjarButton() {
  const hjBtn = getHotjarFeedbackButton();
  if (hjBtn) {
    hjBtn.style.display = 'block';
  }
}

function hideHotjarButton() {
  const hjBtn = getHotjarFeedbackButton();
  if (hjBtn) {
    hjBtn.style.display = 'none';
  }
}
